import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Why Get a Cross-Platform App For Your <span>Business?</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              In recent years, the surge in OS and mobile platforms is
              undeniable. An app not present on these platforms misses potential
              users and revenue. Cross-platform app development addresses this
              gap, broadening your app's reach across various platforms for
              maximum audience and revenue.
            </p>
            <p>
              Elevate your business with a top cross-platform app development
              company, ensuring robust apps that seamlessly reach a diverse
              audience across platforms. Key reasons to choose Cross-platform
              app development:
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Broad Market Reach</h6>
                <p>
                  Reach a wider audience by extending your business presence
                  across various platforms.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Cost and Time Efficiency</h6>
                <p>
                  Optimize development, cut costs with a unified codebase for
                  efficient and economical cross-platform app creation.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Seamless Integration</h6>
                <p>
                  Effortlessly introduce new features and updates to your app,
                  ensuring a smooth and uninterrupted experience for users
                  across all platforms.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Scalability</h6>
                <p>
                  Future-proof your app by adopting scalable solutions to
                  accommodate business growth and technological advancements.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Efficient Development</h6>
                <p>
                  Empowering smart development practices like code re-usability
                  and deployment strategies to achieve significant cost savings.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Faster launch</h6>
                <p>
                  Cross-platform development speeds up production and marketing,
                  utilizing scalable solutions for continuous refinement and
                  updates.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
